import axios from 'api';

// Tenants directory + lifecycle — replaces the legacy /api/customers/ surface.
// All tenant operations are keyed by schema_name, not numeric customer id.
// Provisioning (create/delete) is NOT in the super-admin spec.

export const getCustomersData = (filtersData) => {
  const { page_size, page, search, is_active } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (is_active != null) params.set('is_active', is_active);
  return axios.get(`/api/super/tenants/?${params.toString()}`);
};

export const getCustomerDataById = ({ schema }) => {
  return axios.get(`/api/super/tenants/${schema}/`);
};

// Update tenant name / is_active flag.
export const updateCustomer = (params) => {
  const { schema, ...body } = params;
  return axios.patch(`/api/super/tenants/${schema}/`, body);
};

export const suspendTenant = (schema) => {
  return axios.post(`/api/super/tenants/${schema}/suspend/`);
};

export const activateTenant = (schema) => {
  return axios.post(`/api/super/tenants/${schema}/activate/`);
};

// /api/super/tenants/{schema}/customer/ — read or update the linked CustomerDetails row.
export const getCustomerDetails = (schema) => {
  return axios.get(`/api/super/tenants/${schema}/customer/`);
};

export const updateCustomerDetails = ({ schema, ...body }) => {
  return axios.patch(`/api/super/tenants/${schema}/customer/`, body);
};

// ─── Legacy stubs — removed in super-admin migration, kept as no-ops so imports resolve. ───
import { removedStub } from 'api/_legacy';
export const createCustomer = removedStub('createCustomer');
export const deleteCustomer = removedStub('deleteCustomer');
export const addTenant = removedStub('addTenant');
export const updateTenant = removedStub('updateTenant');
export const getContactsByCustomerId = removedStub('getContactsByCustomerId');
export const getContactById = removedStub('getContactById');
export const createContact = removedStub('createContact');
export const updateContact = removedStub('updateContact');
export const deleteContact = removedStub('deleteContact');
